<div class="page-overlay-wrapper" *ngIf="showSpinner">
  <div class="docestate_spinner"></div>
</div>
